import SectionHeading from "@/pages/home/components/SectionHeading";
import { authenticityGood, authenticityBad } from "@/mocks/siteData";

export default function Authenticity() {
  return (
    <section id="verify" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          eyebrow="Verify"
          title="如何判断一个页面是否正规"
          desc="仿冒页面在细节上往往经不起推敲。把下面两组特征对照着看，多数可疑页面都能被识别出来。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          <div className="p-6 md:p-7 rounded-2xl bg-secondary-50 border border-secondary-200">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-500 text-background-50">
                <i className="ri-shield-check-line text-xl" />
              </span>
              <h3 className="text-lg md:text-xl font-heading font-bold text-secondary-900">
                正规页面通常具备
              </h3>
            </div>
            <ul className="mt-5 space-y-3.5">
              {authenticityGood.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-secondary-600 mt-0.5" />
                  <span className="text-sm leading-relaxed text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="p-6 md:p-7 rounded-2xl bg-primary-50 border border-primary-200">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-alarm-warning-line text-xl" />
              </span>
              <h3 className="text-lg md:text-xl font-heading font-bold text-primary-900">
                可疑页面常见特征
              </h3>
            </div>
            <ul className="mt-5 space-y-3.5">
              {authenticityBad.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-primary-600 mt-0.5" />
                  <span className="text-sm leading-relaxed text-foreground-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 p-5 md:p-6 rounded-2xl bg-accent-100/70 border border-accent-200 flex flex-col sm:flex-row sm:items-center gap-4">
          <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500 text-foreground-950 shrink-0">
            <i className="ri-question-answer-line text-xl" />
          </span>
          <p className="text-sm md:text-base leading-relaxed text-accent-950">
            遇到拿不准的页面时，最稳妥的做法是<span className="font-medium">先离开，再从可信渠道重新进入</span>。多花一分钟核对来源，通常比事后补救更划算。
          </p>
        </div>
      </div>
    </section>
  );
}